import axios, { AxiosError } from 'axios';
import { axiosApiInstancePublic } from '../index';
import { endpoints } from '../endpoints';
import { Tokens, User } from '@tassomutuo-backoffice/types';

interface ILoginResponse {
  tokens: Tokens;
  user: User;
}

export const login = async ({
  email,
  password,
}: {
  email: string;
  password: string;
}): Promise<ILoginResponse> => {
  try {
    const response = await axiosApiInstancePublic.post(endpoints.auth.login, {
      email,
      password,
    });

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const googleLogin = async ({
  code,
}: {
  code: string;
}): Promise<ILoginResponse> => {
  try {
    const response = await axiosApiInstancePublic.post(
      endpoints.auth.googleLogin,
      {
        code,
      }
    );

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const logout = async (refreshToken: string) =>
  await axiosApiInstancePublic.post(endpoints.auth.logout, {
    refreshToken,
  });

export const forgotPassword = async ({
  email,
}: {
  email: string;
}): Promise<void> => {
  try {
    const response = await axiosApiInstancePublic.post(
      endpoints.auth.forgotPassword,
      {
        email,
      }
    );

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};

export const resetPassword = async ({
  password,
  token,
}: {
  password: string;
  token: string;
}): Promise<void> => {
  try {
    const response = await axiosApiInstancePublic.post(
      `${endpoints.auth.resetPassword}?token=${token}`,
      {
        password,
      }
    );

    return response.data;
  } catch (err) {
    const error = err as Error | AxiosError;
    if (axios.isAxiosError(error)) {
      throw error?.response?.data;
    }
    throw err;
  }
};
